import { render, staticRenderFns } from "./TractionStaffVerificationPortal.vue?vue&type=template&id=d77d7872&scoped=true&"
import script from "./TractionStaffVerificationPortal.vue?vue&type=script&lang=js&"
export * from "./TractionStaffVerificationPortal.vue?vue&type=script&lang=js&"
import style0 from "./TractionStaffVerificationPortal.vue?vue&type=style&index=0&id=d77d7872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77d7872",
  null
  
)

export default component.exports